import { Component, HostListener, Input, OnDestroy, OnInit} from '@angular/core';
import { Constant } from '../../../environments/constants';
import { Subscription } from 'rxjs';
import { DataService } from '../../services/context/data.service';
import { UIStateService } from '../../services/context/uistate.service';
import { AppMonitoringService } from '../../services/util/app-monitoring.service';
import * as fromModel from '../../services/models';
import * as Highcharts from 'highcharts';
import addMore from "highcharts/highcharts-more";
import { Utils } from '../../../utils/utils';
//addMore(Highcharts)

@Component({
  selector: 'gp-tax-portfolio',
  templateUrl: './tax-portfolio.component.html',
  styleUrls: ['./tax-portfolio.component.scss']
})
export class TaxPortfolioComponent implements OnInit, OnDestroy {

  protected _storeDataSubscription: Subscription;
  protected _uiStateSubscription: Subscription;

  Highcharts: typeof Highcharts = Highcharts;
  options: Highcharts.Options;
  private chart: Highcharts.Chart;

  isDataAvailable = false;
  yoyCashFlows;
  
  constructor(private dataService: DataService,
      private uiStateService: UIStateService,  
      private appMonitoringService: AppMonitoringService) {    
  }

  ngOnInit(): void {
    //this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWPROGRESSBAR, "TaxPortfolioComponent-ngOnInit", true);
    this.dataService.getPlanAnalysis();    
    this._storeDataSubscription = this.dataService.subscribe((appData: fromModel.IAppData) => this.populateAppData(appData));   
    this._uiStateSubscription =  this.uiStateService.subscribe((uiState: fromModel.IUIState) => this.populateUIContext(uiState));     
  }

  private populateAppData(appData: fromModel.IAppData){    
      this.yoyCashFlows = null;
      this.isDataAvailable = false;
      if(appData && (appData.action===fromModel.DATA_ACTION.UPDATESETTINGS)){                
        this.dataService.getGoalSummary();
        this.dataService.getPlanAnalysis();      
      } else {
      if(appData && appData.action!==fromModel.DATA_ACTION.NONE){      
        let yoyCFs = this.dataService.getPlanAnalysisyoyCashFlows();
        if(yoyCFs!== null){
          if(yoyCFs.Error){
            this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWERRORMSG, "TaxPortfolioComponent-populateAppData - Error", {ShowMsg: true,  MsgType: fromModel.MSGTYPE.ERROR, Msg: Constant.ErrorMsgs.analyticErrorMsg});
          } else {
            this.yoyCashFlows =  yoyCFs;
            this.setChartOptionsData();
            this.isDataAvailable = true;
            this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWPROGRESSBAR, "TaxPortfolioComponent-populateAppData", false);
          }
        }
      }
    }
  }

  populateUIContext(uiState: fromModel.IUIState){     
    if(uiState && uiState.action === fromModel.UI_STATE_ACTION.REFRESH){
      if(uiState.Refresh){
        this.resizeChart();
        this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.REFRESH, "TaxPortfolioComponent-populateUIContext", false);        
      }
      
    }
  }

  private setChartOptionsData(){
    this.options = <Highcharts.Options>Utils.getDefaultChartOptions('','Portfolio Value ($)');
    
    let { tooltip } = this.options;
    tooltip.formatter = function(){
      //console.log(this.points);
      var formatStr = "";          
      if(this.points && this.points.length>0){
        formatStr += '<div class="font16">' + Highcharts.dateFormat('%Y',this.points[0].x) + '</div>';
        var ageSeries = this.points.find(point=>point.series.name === fromModel.CHARTSERIESNAME.Age);
        if(ageSeries){
          var data = ageSeries.series.data.find(data=>data.x === ageSeries.x);
          if(data){
            formatStr += '<span class="font14 pClient">' + data['pName'] + ': <span class="font12">age</span> ' + data['pAge'] + '</span>'; 
            if(data['sDisplayName']){
              formatStr += ' | <span class="font14 sClient">' + data['sName'] + ': <span class="font12">age</span> ' + data['sAge'] + '</span>'; 
            } 
            formatStr += '</br></br>';              
          }
        }                      
        formatStr +=  '<table style="width: 100%">';
        for (var i = 0; i < this.points.length; i++) {
          var point = this.points[i];
          if(point.series.name!==fromModel.CHARTSERIESNAME.Age){        
              // formatStr += '<tr>';
              // formatStr += '<td style="color:'  + point.color + '">' + point.series.name + '</td>';
              // formatStr += '<td style="text-align: right; padding-left:50px"><b> $' + Highcharts.numberFormat(point.y,0,'.',',') + '</b></td>'; 
              // formatStr += '</tr>';
              formatStr += '<tr>';
              formatStr += '<td>';
              formatStr += '<span class="m-r5"><svg width="10" height="10"><circle cx="5" cy="5" r="5" fill="' + point.color + '" /></svg></span>';                
              formatStr += point.series.name;
              formatStr += '</td>';
              formatStr += '<td style="text-align: right; padding-left:50px"><b> $' + Highcharts.numberFormat(point.y,0,'.',',') + '</b></td>'; 
              formatStr += '</tr>';
          }
        }
        formatStr += '</table>';                  
      }
      return formatStr;
    },
    this.options = {...this.options, tooltip};
    
    let { series } = this.options;
    series = this.getChartData(series);
    this.options = {...this.options, series};   
  }

  private getChartData(series){
    let chartSeries = this.dataService.getChartSeries({chartSeriesType: fromModel.CHARTSERIESTYPE.BALANCEBYTAXSTATUS});
    if(chartSeries && chartSeries.series && chartSeries.series.length>0){
      chartSeries.series.forEach(ser => {
        series.push(ser);  
      });    
    }    
    series.push(this.dataService.getChartSeries({chartSeriesType: fromModel.CHARTSERIESTYPE.AGE}).series[0]);
    return series;
  }


  @HostListener('window:resize', ['$event'])
  onResize(){
    if(this.chart) {
      this.chart.reflow();
    }
  }

  resizeChart(){
    setTimeout(() => {
      if(this.chart && this.chart.hasOwnProperty('series')) {
        this.chart.reflow();
      }
    }, 200);
  }

  public chartCallBack = (chart: Highcharts.Chart) => {
    this.chart =  chart;
    setTimeout(() => {
      if(this.chart && this.chart.hasOwnProperty('series')) {
        this.chart.reflow();
      }
    }, 100);
  }

  ngOnDestroy(): void{
    if(this._storeDataSubscription && this._storeDataSubscription !== null){
      this._storeDataSubscription.unsubscribe();
    }
    if(this._uiStateSubscription && this._uiStateSubscription !== null){
      this._uiStateSubscription.unsubscribe();    
    }    
  }
}



// formatter: function(){
//   var formatStr = "";

//   // for (var i = 0; i < this.points.length; i++) {
//   //   var point = this.points[i];
//   //   if(point.series.name==='Expense'){
//   //     formatStr += point['pName'] + ': ' + point['pAge'] + " years <br/>";
//   //     if(point['sName'] && point['sAge']){
//   //       formatStr += point['sName'] + ': ' + point['sAge'] + " years <br/>";
//   //     }
//   //   }
//   // }

//   // for (var i = 0; i < this.points.length; i++) {
//   //   var point = this.points[i];
//   //   if(i===0)
//   //   {
//   //     formatStr += "<b>" + Highcharts.dateFormat('%Y',point.x) + "</b><br/>";
//   //   }
//   //   if(point.series.name!=='Range'){        
//   //     formatStr += '<span style="color:' + point.color + '">●</span> ' + point.series.name + '<b>: $' + Highcharts.numberFormat(point.y,0,'.',',') + '</b><br/>';
//   //   }
//   // }

//   // for (var i = 0; i < this.points.length; i++) {
//   //   var point = this.points[i];
//   //   if(point.series.name==='Expense'){        
//   //     formatStr += '<span style="color:' + point.color + '">●</span> ' + point.series.name + '<b>: $' + Highcharts.numberFormat(point.y,0,'.',',') + '</b><br/>';
//   //   }
//   // }

//   for (var i = 0; i < this.points.length; i++) {
//     var point = this.points[i];
//     if(i===0)
//     {
//       formatStr += '<small>' + Highcharts.dateFormat('%Y',point.x) + '</small>';
//     }
//     //if(point.series['dType']!=='essexp' && point.series['dType']!=='exp'){        
//     if(point.series.name!=='Total Expense' && point.series.name!=='Essential Expense'){        
//       //formatStr += '<span style="color:' + point.color + '">●</span> ' + point.series.name + '<b>: $' + Highcharts.numberFormat(point.y,0,'.',',') + '</b><br/>';
//       formatStr +=  '<table style="width: 100%"><tr><td style="color:'  + point.color + '">' + point.series.name + '</td>' + '<td style="text-align: right; padding-left:50px"><b> $' + Highcharts.numberFormat(point.y,0,'.',',') + '</b></td></tr></table>';
//     }
//   }


//   for (var i = 0; i < this.points.length; i++) {
//     var point = this.points[i];
//     //if(point.series['dType']!=='essexp' && point.series['dType']!=='exp'){        
//     if(point.series.name==='Essential Expense'){        
//       //formatStr += '<span style="color:' + point.color + '">●</span> ' + point.series.name + '<b>: $' + Highcharts.numberFormat(point.y,0,'.',',') + '</b><br/>';
//       formatStr +=  '<table style="width: 100%"><tr style="border-top: 2px solid gray"><td style="color:'  + point.color + '">' + point.series.name + '</td>' + '<td style="text-align: right; padding-left:50px"><b> $' + Highcharts.numberFormat(point.y,0,'.',',') + '</b></td></tr></table>';
//     }
//   }

//   for (var i = 0; i < this.points.length; i++) {
//     var point = this.points[i];
//     //if(point.series['dType']!=='essexp' && point.series['dType']!=='exp'){        
//     if(point.series.name==='Total Expense'){        
//       //formatStr += '<span style="color:' + point.color + '">●</span> ' + point.series.name + '<b>: $' + Highcharts.numberFormat(point.y,0,'.',',') + '</b><br/>';
//       formatStr +=  '<table style="width: 100%"><tr><td style="color:'  + point.color + '">' + point.series.name + '</td>' + '<td style="text-align: right; padding-left:50px"><b> $' + Highcharts.numberFormat(point.y,0,'.',',') + '</b></td></tr></table>';
//     }
//   }



//   return formatStr;
// }



// private setChartOptionsData(){
  //   this.options = {
  //     chart: {
  //       //type: 'area',
  //       style: {
  //         fontSize: '18'
  //       } 
  //     },
  //     title: {
  //         text: ''
  //     },
  //     subtitle: {
  //       text: ''
  //     },
  //     credits: {
  //       enabled: false
  //     },
  //     xAxis: {
  //       title: {              
  //         text: '',
  //         style: {
  //           fontSize: '16'
  //         }
  //       },
  //       labels: {
  //         style: {            
  //             fontSize:'14'
  //         }
  //       },
  //       type: 'datetime',
  //       startOnTick: true,
  //       tickInterval: 1000 * 60 * 60 * 24 * 1825,  
  //       //tickWidth: 0,
  //       //visible: true,
  //       //endOnTick: true,
  //       //showLastLabel: false,
  //       // labels: {
  //       //   enabled: false,
  //       //   style: {                
  //       //     fontSize: '16'
  //       //   }
  //       // },
  //       //showFirstLabel: true,            
  //       //tickWidth: 0,
  //       // tickInterval: 12,
  //       //allowDecimals: false,
  //       //min: 0      
  //     },
  //     yAxis: {
  //       title: {
  //           text: 'Portfolio Value ($)',
  //           style: {
  //             fontSize: '16'
  //           }
  //       },          
  //       labels: {
  //         style: {                
  //             fontSize: '16'
  //         }
  //       },
  //       lineWidth: 0,
  //       //tickInterval: 2,
  //       allowDecimals: false,
  //       //min: 0          
  //     },
  //     legend: {
  //       enabled: true, 
  //       itemStyle:{
  //         fontSize: '14'
  //       }      
  //     },
  //     tooltip: {
  //       shared:true,
  //       useHTML: true,
  //       style:{
  //         color: '#4F528C', 
  //         fontSize: '14',
  //         fontFamily: 'Avenir',
  //         fontWeight: 'bold'
  //       },
  //       formatter: function(){
  //         //console.log(this.points);
  //         var formatStr = "";          
  //         if(this.points && this.points.length>0){
  //           formatStr += '<div class="font16">' + Highcharts.dateFormat('%Y',this.points[0].x) + '</div>';
  //           var ageSeries = this.points.find(point=>point.series.name === fromModel.CHARTSERIESNAME.Age);
  //           if(ageSeries){
  //             var data = ageSeries.series.data.find(data=>data.x === ageSeries.x);
  //             if(data){
  //               formatStr += '<span class="font14 pClient">' + data['pName'] + ': <span class="font12">age</span> ' + data['pAge'] + '</span>'; 
  //               if(data['sDisplayName']){
  //                 formatStr += ' | <span class="font14 sClient">' + data['sName'] + ': <span class="font12">age</span> ' + data['sAge'] + '</span>'; 
  //               } 
  //               formatStr += '</br></br>';              
  //             }
  //           }                      
  //           formatStr +=  '<table style="width: 100%">';
  //           for (var i = 0; i < this.points.length; i++) {
  //             var point = this.points[i];
  //             if(point.series.name!==fromModel.CHARTSERIESNAME.Age){        
  //                 // formatStr += '<tr>';
  //                 // formatStr += '<td style="color:'  + point.color + '">' + point.series.name + '</td>';
  //                 // formatStr += '<td style="text-align: right; padding-left:50px"><b> $' + Highcharts.numberFormat(point.y,0,'.',',') + '</b></td>'; 
  //                 // formatStr += '</tr>';
  //                 formatStr += '<tr>';
  //                 formatStr += '<td>';
  //                 formatStr += '<span class="m-r5"><svg width="10" height="10"><circle cx="5" cy="5" r="5" fill="' + point.color + '" /></svg></span>';                
  //                 formatStr += point.series.name;
  //                 formatStr += '</td>';
  //                 formatStr += '<td style="text-align: right; padding-left:50px"><b> $' + Highcharts.numberFormat(point.y,0,'.',',') + '</b></td>'; 
  //                 formatStr += '</tr>';
  //             }
  //           }
  //           formatStr += '</table>';                  
  //         }
  //         return formatStr;
  //       },
  //     },
  //     plotOptions: {
  //       area: {
  //         stacking: 'normal',
  //         dataLabels: {
  //           enabled: false
  //         }          
  //       },
  //       series: {
  //         stickyTracking: true,
  //         states: {
  //             inactive: {
  //                 opacity: 1
  //             }
  //         }
  //       }        
  //     },
  //     series: []
  //   }; 
  //   let { series } = this.options;
  //   series = this.getChartData(series);
  //   this.options = {...this.options, series};   
  // }